import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=5cd6f9ba&"
import script from "./Accounts.vue?vue&type=script&lang=js&"
export * from "./Accounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Accounts.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent03/user/3333/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cd6f9ba')) {
      api.createRecord('5cd6f9ba', component.options)
    } else {
      api.reload('5cd6f9ba', component.options)
    }
    module.hot.accept("./Accounts.vue?vue&type=template&id=5cd6f9ba&", function () {
      api.rerender('5cd6f9ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Merchant/Accounts.vue"
export default component.exports